import styled from "styled-components"

import Form from "@irati/ui/src/Form"
import {H3} from "@irati/ui/src/Headings"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {Hr} from "@irati/ui/src/Layout"

export const StyledForm = styled(Form)`
  textarea {
    resize: vertical;
    min-height: 40px;
    height: 105px;
  }
`

export const Flex = styled.div`
  display: flex;
`

export const StyledHr = styled(Hr)`
  margin-top: 0;
  margin-bottom: ${padding.tiny};
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: ${padding.tiny};
  ${H3} {
    margin-right: 15px;
    padding-bottom: 10px;
    ${minWidthMedia.tablet`
      padding-bottom: 0;
    `}
  }
  ${minWidthMedia.tablet`
    flex-direction: row;
  `}
`
